import { useMutation, useQueryClient } from '@tanstack/react-query';
import { ALERT_MODAL_STATUS } from '../../../../constant/Common/Modal/Alert/status';
import postTruckData from '../../../../service/Safety/Truck/Post/postTruckData';
import safetyTruckKeys from '../keys';
import useControlToast from '../../../Common/Toast/useControlToast';
import { SUCCESS_SAVE } from '../../../../constant/Common/Message/success';
import updateButtonDisabled from '../../../../util/Common/Controller/Handler/updateButtonDisabled';

const usePostTruckData = ({ ...props }) => {
  const queryClient = useQueryClient();
  const { addToast } = useControlToast();

  const { setAlertModalStatus, setAlertOpen, setModalOpen } = props;

  const mutator = useMutation({
    mutationFn: postTruckData,
    onSettled: (data, error, variables) => {
      if (variables?.buttonRef)
        updateButtonDisabled({ ref: variables.buttonRef, disabled: false });
    },
    onSuccess: () => {
      setModalOpen?.(prev => false);
      queryClient?.invalidateQueries({ queryKey: safetyTruckKeys?.listData() });
      addToast({ message: SUCCESS_SAVE });
    },
    onError: error => {
      setAlertModalStatus(prev => {
        return {
          status: ALERT_MODAL_STATUS?.ERROR,
          message: error?.message,
        };
      });
      setAlertOpen(prev => true);
    },
  });

  return { ...mutator };
};

export default usePostTruckData;
